import { Center } from '@vimeo/bokeh';

import { ErrorContent } from '../components/ErrorContent';

interface Props {
  error: Error;
}

export const ErrorView = ({ error, children }: React.PropsWithChildren<Props>) => (
  <>
    {children}
    <Center flex="1" backgroundColor="surface" p={200}>
      <ErrorContent error={error} />
    </Center>
  </>
);
